<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'quotationRecordDetail',
})
</script>
<template>
  <div class="main detail-page">
    <!-- 店铺信息 -->
    <a-card title="店铺信息" class="mb20">
      <a-spin :spinning="state.loading">
        <a-row :gutter="[16, 24]">
          <a-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="detail-item">
              <span class="detail-label">店铺类型：</span>
              <span class="detail-value">{{ detailInfo.storeInfo?.storeTypeStr || '-' }}</span>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="detail-item">
              <span class="detail-label">场所业态类型：</span>
              <span class="detail-value">{{ detailInfo.storeInfo?.venueTypeStr || '-' }}</span>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="detail-item">
              <span class="detail-label">所属行业：</span>
              <span class="detail-value">{{ detailInfo.storeInfo?.industryStr || '-' }}</span>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="detail-item">
              <span class="detail-label">店铺名称：</span>
              <span class="detail-value">{{ detailInfo.storeInfo?.storeName || '-' }}</span>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="detail-item">
              <span class="detail-label">店铺地址：</span>
              <span class="detail-value">{{ storeAddressText || '-' }}</span>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="detail-item">
              <span class="detail-label">店铺面积：</span>
              <span class="detail-value">{{ formatArea(detailInfo.storeInfo?.buildingArea) }}</span>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="detail-item">
              <span class="detail-label">联系人：</span>
              <span class="detail-value">{{ detailInfo.storeInfo?.contactPerson || '-' }}</span>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="detail-item">
              <span class="detail-label">联系电话：</span>
              <span class="detail-value">{{ detailInfo.storeInfo?.contactPhone || '-' }}</span>
            </div>
          </a-col>
        </a-row>
      </a-spin>
    </a-card>

    <!-- 报价记录 + 用户信息/状态信息 -->
    <div class="bottom-panel">
      <a-row :gutter="[20, 20]" class="bottom-panel-row">
        <a-col :xs="24" :lg="12" class="bottom-panel-col">
          <a-card title="报价记录" class="gray-card">
            <a-spin :spinning="state.loading">
              <div class="quotation-detail">
                <div class="detail-item mb16 quotation-no-row">
                  <span class="detail-label">报价单号：</span>
                  <span class="detail-value quotation-no">{{ detailInfo.quotationNo || '-' }}</span>
                </div>

                <div class="detail-item mb16">
                  <span class="detail-label quotation-store-label">店铺名称：</span>
                  <span class="quotation-store-name">{{ detailInfo.storeName || '-' }}</span>
                </div>

                <div class="detail-item mb24">
                  <span class="detail-label">店铺地址：</span>
                  <span class="detail-value">{{ quotationAddressText }}</span>
                </div>

                <a-row :gutter="[16, 24]">
                  <a-col :xs="24" :sm="12">
                    <div class="detail-item">
                      <span class="detail-label">所属城市：</span>
                      <span class="detail-value">{{ detailInfo.cityStr || '-' }}</span>
                    </div>
                  </a-col>
                  <a-col :xs="24" :sm="12">
                    <div class="detail-item">
                      <span class="detail-label">所属行业：</span>
                      <span class="detail-value">{{ detailInfo.industryStr || '-' }}</span>
                    </div>
                  </a-col>
                  <a-col :xs="24" :sm="12">
                    <div class="detail-item">
                      <span class="detail-label">店铺面积：</span>
                      <span class="detail-value">{{ formatArea(detailInfo.buildingArea) }}</span>
                    </div>
                  </a-col>
                  <a-col :xs="24" :sm="12">
                    <div class="detail-item">
                      <span class="detail-label">改造总价：</span>
                      <span class="detail-value">{{ formatPrice(detailInfo.totalPrice) }}</span>
                    </div>
                  </a-col>
                </a-row>

                <a-divider />

                <div class="quotation-desc-section">
                  <div class="quotation-desc-label">报价说明：</div>
                  <div class="quotation-desc">{{ detailInfo.quotationDesc || '-' }}</div>
                </div>
              </div>
            </a-spin>
          </a-card>
        </a-col>

        <a-col :xs="24" :lg="12" class="bottom-panel-col">
          <a-card title="用户信息" class="gray-card mb20">
            <a-spin :spinning="state.loading">
              <a-row :gutter="[16, 24]">
                <a-col :xs="24" :sm="12">
                  <div class="detail-item">
                    <span class="detail-label">用户昵称：</span>
                    <span class="detail-value">{{ detailInfo.userNickname || '-' }}</span>
                  </div>
                </a-col>
                <a-col :xs="24" :sm="12">
                  <div class="detail-item">
                    <span class="detail-label">手机号：</span>
                    <span class="detail-value">{{ detailInfo.phone || '-' }}</span>
                  </div>
                </a-col>
              </a-row>
            </a-spin>
          </a-card>

          <a-card title="状态信息" class="gray-card">
            <a-spin :spinning="state.loading">
              <a-row :gutter="[16, 24]">
                <a-col :xs="24" :sm="12">
                  <div class="detail-item">
                    <span class="detail-label">报价状态：</span>
                    <span class="detail-value">{{ formatStatus(detailInfo.statusStr) }}</span>
                  </div>
                </a-col>
                <a-col :xs="24" :sm="12">
                  <div class="detail-item">
                    <span class="detail-label">报价时间：</span>
                    <span class="detail-value">{{ detailInfo.quoteTime || '-' }}</span>
                  </div>
                </a-col>
              </a-row>
            </a-spin>
          </a-card>
        </a-col>
      </a-row>

      <div class="detail-footer">
        <a-button class="detail-close-btn" @click="goBack">关闭</a-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup name="quotationRecordDetail">
import { reactive, ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useQuotation } from '@/store/quotation/quotation'

const route = useRoute()
const router = useRouter()
const quotationApi = useQuotation()

const detailInfo = ref<Record<string, any>>({})

const state = reactive({
  loading: false
})

const storeAddressText = computed(() => {
  return [detailInfo.value.storeInfo?.areaStr, detailInfo.value.storeInfo?.detailAddress].filter(Boolean).join('') || '-'
})

const quotationAddressText = computed(() => {
  return [detailInfo.value.areaName, detailInfo.value.storeAddress].filter(Boolean).join('') || '-'
})

const formatPrice = (price: number | undefined) => {
  if (price === undefined || price === null) return '-'
  return Number(price).toFixed(2)
}

const formatArea = (area: number | undefined) => {
  if (area === undefined || area === null) return '-'
  return `${area}m²`
}

const formatStatus = (status: string | undefined) => {
  if (!status) return '-'
  if (status === '未失效') return '有效'
  return status
}

const goBack = () => {
  router.push({ path: '/quotation/record' })
}

onMounted(async () => {
  const query = route.query as { id: string }
  if (!query.id) {
    goBack()
    return
  }
  state.loading = true
  try {
    const data: any = await quotationApi.getQuotationRecordDetail(query.id)
    detailInfo.value = data || {}
  } catch {
    // baseService 已统一提示错误信息
  } finally {
    state.loading = false
  }
})
</script>

<style lang="less" scoped>
.detail-page {
  .mb16 {
    margin-bottom: 16px;
  }

  .mb20 {
    margin-bottom: 20px;
  }

  .mb24 {
    margin-bottom: 24px;
  }

  :deep(.ant-card-head) {
    font-size: 22px;
    font-weight: bold;
    color: #222222;
    border-bottom: 1px solid #d9d9d9;
  }

  :deep(.ant-card-body) {
    padding: 24px 28px 28px;
  }

  .bottom-panel {
    background: #fff;
    padding: 24px 28px 28px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02);

    .bottom-panel-row {
      display: flex;
    }

    .bottom-panel-col {
      display: flex !important;
      flex-direction: column;
    }

    .gray-card {
      background: #f5f5f5;
      border: none;
      box-shadow: none;
      display: flex !important;
      flex-direction: column;
      flex: 1;

      :deep(.ant-card-head) {
        background: #f5f5f5;
        border-bottom: 1px solid #e2e2e4;
        flex-shrink: 0;
      }

      :deep(.ant-card-body) {
        flex: 1;
      }
    }
  }

  .detail-item {
    display: flex;
    align-items: flex-start;
    font-size: 16px;
    line-height: 1.5;

    .detail-label {
      color: #222222;
      white-space: nowrap;
      flex-shrink: 0;
    }

    .detail-value {
      color: #333;
      word-break: break-all;
    }
  }

  .quotation-detail {
    .quotation-no-row {

      .detail-label,
      .quotation-no {
        color: #90909a;
        font-size: 16px;
      }
    }

    .quotation-store-label {
      font-size: 20px;
      font-weight: bold;
      color: #1e3f70;
    }

    .quotation-store-name {
      font-size: 20px;
      font-weight: bold;
      color: #1e3f70;
      word-break: break-all;
    }

    .quotation-desc-section {
      .quotation-desc-label {
        margin-bottom: 8px;
        color: #757070;
        font-size: 16px;
        font-weight: bold;
        line-height: 1.5;
      }

      .quotation-desc {
        color: #757070;
        font-size: 14px;
        line-height: 1.6;
        word-break: break-all;
      }
    }

    :deep(.ant-divider) {
      margin: 20px 0;
      border-color: #e8e8e8;
    }
  }

  .detail-footer {
    display: flex;
    justify-content: center;
    padding: 40px 0 20px;

    .detail-close-btn {
      width: 120px;
      height: 40px;
      border: 1px solid #0c418f;
      border-radius: 20px !important;
      color: #0c418f;
      font-size: 16px;

      &:hover {
        color: #0d479c;
        border-color: #0d479c;
      }
    }
  }
}
</style>
